module.exports = __webpack_public_path__ + "img/oviedo.496f6666.jpg";